import Banner1 from "./banner1.jpg";
import Banner2 from "./banner2.jpg";
import Banner3 from "./banner3.jpg";

 const sliderImage = [
  {
    urls: Banner1,
  },
  {
    urls: Banner2,
  },
  {
    urls: Banner3,
  }
];
export default sliderImage
